import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials: true so the session_token httpOnly cookie flows on every request
const client = axios.create({ baseURL: API, withCredentials: true });
export { client };

export const fetchRoutes = async (params = {}) => {
    const { data } = await client.get("/routes", { params });
    return data;
};

export const fetchRoute = async (slug) => {
    const { data } = await client.get(`/routes/${slug}`);
    return data;
};

export const fetchDestinations = async () => {
    const { data } = await client.get("/destinations");
    return data;
};

export const fetchDestination = async (slug) => {
    const { data } = await client.get(`/destinations/${slug}`);
    return data;
};

export const submitContact = async (payload) => {
    const { data } = await client.post("/contact", payload);
    return data;
};

export const fetchPhotos = async () => {
    const { data } = await client.get("/photos");
    return data;
};

export const fetchPhotosByRegion = async (regionSlug) => {
    const { data } = await client.get(`/photos/by-region/${regionSlug}`);
    return data;
};

export const photoUrl = (relative) =>
    relative && relative.startsWith("/api/") ? `${BACKEND_URL}${relative}` : relative;

export const gpxUrl = (slug) => `${API}/routes/${slug}/gpx`;
export const shareUrl = (slug) => `${API}/share/${slug}`;
export const ogImageUrl = (slug) => `${API}/routes/${slug}/og.png`;

export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_moto-routes-ireland/artifacts/ot8frup4_7607fc_c41badd8529047ba8b3928b8ac22d190-mv2.gif";

// ------------------ Auth ------------------
export const authRegister = (payload) => client.post("/auth/register", payload).then((r) => r.data);
export const authLogin = (payload) => client.post("/auth/login", payload).then((r) => r.data);
export const authLogout = () => client.post("/auth/logout").then((r) => r.data);
export const authMe = () => client.get("/auth/me").then((r) => r.data);
export const authExchangeGoogleSession = (session_id) => client.post("/auth/session", { session_id }).then((r) => r.data);

// ------------------ Ridden (user-scoped) ------------------
export const fetchMyRidden = () => client.get("/me/ridden").then((r) => r.data);
export const toggleMyRidden = (route_slug, waypoint_key) =>
    client.post("/me/ridden/toggle", { route_slug, waypoint_key }).then((r) => r.data);
export const mergeMyRidden = (ridden) => client.post("/me/ridden/merge", { ridden }).then((r) => r.data);

// ------------------ User Photos ------------------
export const uploadMyPhoto = ({ file, visibility, caption }) => {
    const form = new FormData();
    form.append("file", file);
    form.append("visibility", visibility);
    if (caption) form.append("caption", caption);
    return client
        .post("/me/photos", form, { headers: { "Content-Type": "multipart/form-data" } })
        .then((r) => r.data);
};
export const listMyPhotos = () => client.get("/me/photos").then((r) => r.data);
export const updateMyPhoto = (photo_id, payload) =>
    client.patch(`/me/photos/${photo_id}`, payload).then((r) => r.data);
export const deleteMyPhoto = (photo_id) => client.delete(`/me/photos/${photo_id}`).then((r) => r.data);
export const communityPhotosUrl = `${API}/photos/community`;
export const fetchCommunityPhotos = () => client.get("/photos/community").then((r) => r.data);
export const userPhotoImageUrl = (photo_id) => `${API}/me/photos/${photo_id}/image`;
